/**
 * 
 * DataLog Model
 *
 */

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';


class DataLog extends BaseAPI {
    constructor() {
        super();

        this.fields = [
            {
                field: 'name',

                caption: 'Name',
            },
        ];
    }

    get id() {
        return 'id';
    }

    get getEndpoint() {
        return 'data_logs';
    }

    get path() {
        return `data_logs`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `data_logs`;
    }

    /*
    * Fetch audit logs 
    */
    getAuditLog(formBody,id) {
        //take mode and submode from formbody
        const {mode , submode}= formBody.auditLog || formBody
        //set initial url with mode 
        let url=`data-log/get-datalog?module=${mode}&id=${id}`
        //if submode is present then filter based on that also
        if (submode){
            url+=`&sub_module=${submode}`
        }
        return ApiUtils.get({url});
    }
}


export default DataLog;
